import { ChainsReportState } from 'features/chains/store/chains-store';

export const selectChains = (state: ChainsReportState) => {
    return state.chains;
};

export const selectChainsUiState = (state: ChainsReportState) => {
    return state.chainsUi;
};
